import React from "react";
import { withRouter } from "react-router-dom";
import { compose, getActiveShop } from "../constants/utility";
import { withAuthentication } from "./withAuthentication";

const withAuthorization = (condition) => (Component) => {
  class WithAuthorization extends React.Component {
    shop = getActiveShop(this.props.user) || {};

    componentDidMount() {
      if (
        !/active/i.test(this.shop.status) &&
        this.props.user.email &&
        this.props.user.emailVerified
      ) {
        return this.props.history.push("/pricing");
      }

      if (!condition(this.props.user) && this.props.user.type !== "Vendor") {
        this.props.user.logout();
      }
    }

    render() {
      let render = null;

      if (
        condition(this.props.user) &&
        this.props.user.emailVerified &&
        !/true/.test(this.shop.suspended)
      ) {
        render = <Component {...this.props} />;
      }

      return render;
    }
  }

  return compose(withRouter, withAuthentication)(WithAuthorization);
};

export default withAuthorization;
